import { BulkAssignListState } from '../types/ImplementationBulkAssign'

const storageKey = 'internal-ie-bulk-assign-edit'

// Every page load passes through the Keycloak check-sso redirect, which drops history state, so a reloaded edit page
// reads its screenshots from the tab's session storage.
export type StoredBulkAssignEdit = {
  selection: string
  screenshotIds: string[]
  // The list the edit page was opened from, with the state to restore it.
  returnTo: string
  listState: BulkAssignListState
}

export const saveBulkAssignEdit = (edit: Omit<StoredBulkAssignEdit, 'selection'>): string | undefined => {
  const selection = Date.now().toString(36)
  try {
    window.sessionStorage.setItem(storageKey, JSON.stringify({ ...edit, selection }))
    return selection
  } catch {
    return undefined
  }
}

export const readBulkAssignEdit = (selection: string | null): StoredBulkAssignEdit | undefined => {
  if (!selection) return undefined
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(storageKey) ?? 'null')
    if (stored?.selection !== selection || !Array.isArray(stored.screenshotIds)) return undefined
    return {
      selection,
      screenshotIds: stored.screenshotIds.filter((id: unknown) => typeof id === 'string'),
      returnTo: typeof stored.returnTo === 'string' && stored.returnTo.startsWith('/internal/') ? stored.returnTo : '',
      listState: stored.listState && typeof stored.listState === 'object' ? stored.listState : {},
    }
  } catch {
    return undefined
  }
}
